import React from 'react';
import { motion } from 'framer-motion';
import { trackPixelEvent } from './MetaPixel';
export function HeroSection() {
  return <section className="relative pt-8 pb-16 md:pt-12 md:pb-24 overflow-hidden bg-brand-brown" data-id="element-61">
      {/* Full-bleed hero image that blends into the dark background */}
      <motion.div initial={{
      opacity: 0,
      scale: 1.02
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 1.2,
      ease: 'easeOut'
    }} className="relative w-full" data-id="element-62">
        <img src="https://cdn.magicpatterns.com/uploads/khKBvDWGBtjEXoTBVKKrrQ/_Anuncio_de_Facebook_1200_x_628_.png" alt="Atajo al Éxito - Mentoría 1:1 by Careliz Griman" className="w-full h-auto object-cover" style={{
        WebkitMaskImage: 'radial-gradient(ellipse 100% 90% at center, black 55%, transparent 100%)',
        maskImage: 'radial-gradient(ellipse 100% 90% at center, black 55%, transparent 100%)'
      }} data-id="element-63" />
        {/* Soft dark fade overlays to dissolve hard edges into the page */}
        <div className="pointer-events-none absolute inset-x-0 top-0 h-24 bg-gradient-to-b from-brand-brown to-transparent" data-id="element-64"></div>
        <div className="pointer-events-none absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-brand-brown to-transparent" data-id="element-65"></div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-16 md:w-32 bg-gradient-to-r from-brand-brown to-transparent" data-id="element-66"></div>
        <div className="pointer-events-none absolute inset-y-0 right-0 w-16 md:w-32 bg-gradient-to-l from-brand-brown to-transparent" data-id="element-67"></div>
      </motion.div>

      {/* Tagline + CTA below the image */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8,
      delay: 0.4,
      ease: 'easeOut'
    }} className="relative max-w-3xl mx-auto px-6 text-center -mt-4 md:-mt-8" data-id="element-68">
        <p className="text-xl md:text-2xl lg:text-3xl text-brand-cream mb-10 font-normal leading-relaxed italic font-serif" data-id="element-69">
          La mentoría personalizada{' '}
          <span className="text-brand-gold not-italic font-medium" data-id="element-70">
            solo para mujeres
          </span>{' '}
          que quieren construir un negocio digital desde cero con{' '}
          <span className="text-brand-gold not-italic font-medium" data-id="element-71">
            claridad
          </span>
          ,{' '}
          <span className="text-brand-gold not-italic font-medium" data-id="element-72">
            estrategia
          </span>
          ,{' '}
          <span className="text-brand-gold not-italic font-medium" data-id="element-73">
            dirección
          </span>{' '}
          y{' '}
          <span className="text-brand-gold not-italic font-medium" data-id="element-74">
            confianza
          </span>
          .
        </p>
        <a href="https://wa.me/message/LI4MMCWOOCMYN1" target="_blank" rel="noopener noreferrer" onClick={() => trackPixelEvent('Lead', {
        content_name: 'Hero CTA - Agenda una llamada',
        source: 'hero'
      })} className="btn-gold-shine inline-block px-10 py-4 rounded-full uppercase tracking-widest text-sm font-semibold" data-id="element-75">
          Agenda una llamada ahora
        </a>
      </motion.div>
    </section>;
}